<div class="page-container">
  <app-card>
    <app-card-content>
      <app-log-controls />
    </app-card-content>
  </app-card>
</div>